module.exports = __webpack_public_path__ + "img/img1.d203219f.jpg";